import type { PersonCommandData } from '@festina/legalentity-general-types/legalentity'
import type { ExcludeString } from '@festina-life/core'

import { BirthDateChangeCommand } from '../../legalentityactions/BirthDateChangeCommand'
import { CreatePersonCommand } from '../../legalentityactions/CreatePersonCommand'
import { EndRelationshipCommand } from '../../legalentityactions/EndRelationshipCommand'
import { GenderChangeCommand } from '../../legalentityactions/GenderChangeCommand'
import { PersonDeceasedCommand } from '../../legalentityactions/PersonDeceasedCommand'
import { PersonNameChangeCommand } from '../../legalentityactions/PersonNameChangeCommand'
import { StartPartnershipCommand } from '../../legalentityactions/StartPartnershipCommand'
import { UpdateCommunicationPreferenceCommand } from '../../legalentityactions/UpdateCommunicationPreferenceCommand'
import { UpdatePartnershipCommand } from '../../legalentityactions/UpdatePartnershipCommand'
import { LegalentityCommandModalButtonFallback } from '../LegalentityCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'
import { sharedLegalentityCommands } from './sharedLegalentityCommands'

export const personCommands: CommandDataRecord<
  ExcludeString<PersonCommandData['_type']>
> &
  typeof sharedLegalentityCommands = {
  ...sharedLegalentityCommands,
  BirthDateChangeCommandData: BirthDateChangeCommand,
  CreatePersonCommandData: CreatePersonCommand,
  EndPartnershipCommandData: EndRelationshipCommand,
  GenderChangeCommandData: GenderChangeCommand,
  InformationalPersonExternalIdChangedCommandData:
    LegalentityCommandModalButtonFallback, // has a "create" with `<ExternalIdChangeDataPersonCommand`
  PartnerBirthdateChangeCommandData: LegalentityCommandModalButtonFallback,
  PartnerDeceasedCommandData: LegalentityCommandModalButtonFallback,
  PartnerIdentificationChangeCommandData: LegalentityCommandModalButtonFallback,
  PartnerNameChangeCommandData: LegalentityCommandModalButtonFallback,
  PersonDeceasedCommandData: PersonDeceasedCommand,
  PersonNameChangeCommandData: PersonNameChangeCommand,
  PersonRelocationCommandData: LegalentityCommandModalButtonFallback,
  SetPersonStateCommandData: LegalentityCommandModalButtonFallback,
  StartPartnershipCommandData: StartPartnershipCommand,
  UpdateCommunicationPreferenceCommandData:
    UpdateCommunicationPreferenceCommand,
  UpdatePartnershipCommandData: UpdatePartnershipCommand,
  UpdatePersonCommandData: LegalentityCommandModalButtonFallback,
} as const
